<template>
	<div class="ai">
		<div class="container">
			<Nav :currentPage='curpage'></Nav>
			<!-- 轮播图 -->
			<section class="carousel-container">
				<div id="carousel-example-generic" class="carousel slide my-slide" data-ride="carousel">
					<div class="carousel-inner">
						<div class="item" :class="{active: index=='0'}" v-for="(item, index) in bannerList" :key="index">
							<img :src="item.picture_url" alt style="max-width: 100%;margin: 0 auto;" />
							<div class="carousel-caption" v-if="item.tile !=''">{{item.title}}</div>
						</div>
					</div>
				</div>
			</section>

			<div class="diwen1">
				<section class="section1 mbt0">
					<div class="sec1_title">
						<p>助力量刑规范化改革</p>
					</div>
					<div class="lrbox box_1">
						<div class="content flex_1_content">
							<p>
								量刑规范化改革是法治进步和时代发展的客观需要。“规范裁量权，将量刑纳入法庭审理程序”是中央确定的重大司法改革项目。
							</p>
							<p>『智能刑期预测系统』通过运用数据挖掘技术和人工智能、深度学习对庞大数量的已决案件数据进行持续的类型化段落分析，为公诉人的待决案件量刑提供参考，从而真正实现“同等情况，同等对待”的平等原则。</p>
						</div>
					</div>
				</section>

				<section class="section1">
					<div class="sec1_title">
						<p>四大特点</p>
						<p style="color: #cecece;font-size: 14px;">INTELLIGENT TOOL</p>
					</div>
					<div class="lrbox box_1">
						<img src="../../assets/images/xqyc_1.png" alt="" class="xqyc_1">
						<div class="content">
							<p class="con_title_1 txtCenter">科学辅助</p>
							<p>
								利用大数据、人工智能等计算机技术，根据相关法律法规的规定，能够快速准确地得出量刑建议，用户同时可根据案件实际情况对量刑幅度进行调整。人工智能为量刑规范化注入智能力量，为保证司法公正提供科学化的工具。
							</p>
						</div>
					</div>

					<div class="lrbox box_1">
						<div class="content">
							<p class="con_title_1 txtCenter">精准透明</p>
							<p>
								建立量刑评估机制，通过量化的指标项，实现对量刑的精细预测，从而实现量刑建议的规范化、精准化、科学化，有利于增强量刑建议的合理性，提升司法的透明化。
							</p>
						</div>
						<img src="../../assets/images/xqyc_2.png" alt="" class="xqyc_2">
					</div>

					<div class="lrbox box_1">
						<img src="../../assets/images/xqyc_3.png" alt="" class="xqyc_3">
						<div class="content">
							<p class="con_title_1 txtCenter">高效减负</p>
							<p>
								大幅度减轻办案人员同案类案的量刑办案工作量，从而有效缓解“案多人少”的矛盾，同时可使办案人员将更多精力投入到繁案的精细化办理中，从而合理配置司法资源，在确保司法公正基础上进一步提高司法效率。
							</p>
						</div>
					</div>

					<div class="lrbox box_1">
						<div class="content">
							<p class="con_title_1 txtCenter">智能关联</p>
							<p>
								智能推送与业务结点相关的法律法规、司法案例、法学资料作为办案人员具体量刑的参考，建立起量刑步骤与法律信息之间的充分关联，为办案人员量刑提供智能、动态的法律信息支持。
							</p>
						</div>
						<img src="../../assets/images/xqyc_4.png" alt="" class="xqyc_4">
					</div>

				</section>

				<section class="section1" style="padding-top: 0;">
					<div class="sec1_title" style="margin-bottom: 88px;">
						<p>六大功能</p>
					</div>
					<div class="lrbox">
						<div class="lr_item">
							<img src="../../assets/images/xqyc_5.png" alt="" class="xqyc_5">
							<p class="lr_title_col">文书上传</p>
							<p class="lr_title">文书可上传并识别，根据识别结果，系统支持涉案量刑情节的查看和处理，推送相关法律法规、类案裁判、专家观点等。</p>
						</div>
						<div class="lr_item">
							<img src="../../assets/images/xqyc_6.png" alt="" class="xqyc_6">
							<p class="lr_title_col">智能量刑</p>
							<p class="lr_title">系统内置量刑评估机制，通过量化的指标项，实现对量结果的预测，办案人员只需输入或选择量刑情节并提交，系统便可自动计算出量刑结果，并提供量刑依据及生成量刑结果分析。</p>
						</div>
					</div>

					<div class="lrbox">
						<div class="lr_item">
							<img src="../../assets/images/xqyc_7.png" alt="" class="xqyc_7">
							<p class="lr_title_col">一键生成文书</p>
							<p class="lr_title">
								在量刑模块中，办案人员根据系统量刑结果及案件实际情况进行量刑幅度确定后，系统可一键生成量刑建议书。根据文书上传自动识别的结果，量刑建议书中对其中的法定、酌定情节进行归类，并根据案情自动生成最终的量刑建议。
							</p>
						</div>
						<div class="lr_item">
							<img src="../../assets/images/xqyc_8.png" alt="" class="xqyc_8">
							<p class="lr_title_col">类案推送</p>
							<p class="lr_title">系统支持自动推送与当前案件最紧密相关的法律法规与案例,办案人员可查看相关依据,以实现类案同办的效果</p>
						</div>
					</div>

					<div class="lrbox">
						<div class="lr_item">
							<img src="../../assets/images/xqyc_9.png" alt="" class="xqyc_9">
							<p class="lr_title_col">用户管理</p>
							<p class="lr_title">
								工作人员可以根据实际情况添加、编辑部门、用户，也可以输入角色名称并进行权限配置。
							</p>
						</div>
						<div class="lr_item">
							<img src="../../assets/images/xqyc_10.png" alt="" class="xqyc_10">
							<p class="lr_title_col">配置管理</p>
							<p class="lr_title">提供灵活开放的数据接口，扩展性强，能够支持与已有信息系统的无缝对接。</p>
						</div>
					</div>
				</section>
			</div>

			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import Footer from 'components/footer.vue'
import Nav from 'components/nav.vue'
/*global require*/

export default {
  name: 'Xqyc',
  data() {
    return {
      curpage: 'product',
      bannerList: [
        {
          picture_url: require('../../assets/images/xqyc_banner.png'),
          title: ''
        }
      ]
    }
  },
  components: {
    Footer,
    Nav
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ai {
	margin: 0 auto;
}
.txtCenter {
	text-align: center !important;
}
.txtLeft {
	text-align: left !important;
}
.txtRight {
	text-align: right !important;
}
.pt0 {
	padding-top: 0 !important;
}
.pt50 {
	padding-top: 50px !important;
}
.mbt0 {
	margin-bottom: 0 !important;
}
.mtd90 {
	margin: 90px 0 90px !important;
}
.mt70 {
	margin-top: 70px !important;
}
.img_banner {
	width: 100%;
	height: 100%;
}
.container {
	width: 100%;
	padding: 0;
	margin: 0 auto;
	position: relative;
}
.diwen1 {
	background: url('../../assets/images/xqyc_bkg.png') no-repeat 50%;
	margin: 0 auto;
}
.section1 {
	width: 1020px;
	padding-top: 110px;
	margin: 0px auto 150px;
	text-align: center;
	position: relative;
}

.sec1_title {
	position: relative;
	p {
		padding: 0;
		font-size: 30px;
		color: #000;
	}
}

.sec1_title::after {
	content: '';
	position: absolute;
	top: 120%;
	left: 46%;
	width: 94px;
	height: 5px;
	background: #0066ff;
}
.title_content {
	margin: 90px auto 56px;
	text-align: center;
	width: 500px;
	line-height: 24px;
}
.lrbox {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 50px;
	.flex_1_content {
		flex: 0 0 700px !important;
		margin: 0 auto;
		p {
			text-indent: 30px;
		}
	}
	.content {
		flex: 0 0 428px;
		text-align: left;
		text-indent: 20px;
		line-height: 36px;
		margin-top: 30px;
		.con_title_1 {
			text-align: left;
			color: #0064ff;
			font-size: 16px;
		}
	}
	.xqyc_1 {
		flex: 0 0 394px;
		width: 394px;
		height: 240px;
	}
	.xqyc_2 {
		flex: 0 0 390px;
		width: 390px;
		height: 254px;
	}
	.xqyc_3 {
		flex: 0 0 372px;
		width: 372px;
		height: 226px;
	}
	.xqyc_4 {
		width: 366px;
		height: 226px;
	}
	.xqyc_5 {
		width: 236px;
		height: 190px;
	}
	.xqyc_6 {
		width: 276px;
		height: 194px;
	}
	.xqyc_7 {
		width: 252px;
		height: 194px;
	}
	.xqyc_8 {
		width: 240px;
		height: 200px;
	}
	.xqyc_9 {
		width: 240px;
		height: 182px;
	}
	.xqyc_10 {
		width: 270px;
		height: 180px;
	}
	.lr_item {
		width: 375px;
	}
	.lr_title_col {
		margin: 42px 0 28px;
		text-align: center;
		font-size: 16px;
		color: #0066ff;
	}
	.lr_title {
		text-align: left;
		text-indent: 20px;
		font-size: 12px;
		color: #000;
		line-height: 30px;
	}
}
.box_1 {
	margin-top: 84px;
}
.img_zscq_2 {
	width: 487px;
	height: 398px;
	text-align: center;
}
@media screen and (max-width: 1000px) {
	.container {
		.diwen1 {
			background: #fff;
		}
	}
}
.carousel-caption {
	bottom: -10px;
}
.el-carousel__indicators--outside {
	display: none;
}
</style>
